// extracted by mini-css-extract-plugin
export default {"highlightedPoint":"ClickableHighlightedText__highlightedPoint___vbMrG"};